import get from 'lodash/get';
import { getDate } from '../AvailabilityCalendar/date-utils';
import REPVISITS_LOCATION_TYPE from '../../utils/repvisits-location-types';

export const cancellationPermitted = (eventDate, deadline) => {
  const deadLineMilliSeconds = deadline * 24 * 60 * 60 * 1000;
  const deadlineDate = eventDate - deadLineMilliSeconds;
  const now = new Date();
  return now <= deadlineDate;
};

export const isVisitFuture = (eventDate) => {
  const now = new Date();
  return (now <= eventDate);
};

export const deadlinePassed = (deadlineDate) => {
  const now = new Date();
  const deadlineMidnight = new Date(deadlineDate);
  deadlineMidnight.setDate(deadlineMidnight.getDate() + 1);

  return now >= deadlineMidnight;
};

export function getAppointmentFromProps(props) {
  const appointments = get(props, 'node.appointments', []);
  return appointments.find((appointment) => appointment.id === props.appointmentId);
}

export const prepareRender = (props, state) => {
  const { node, onlyVisitUrl } = props;
  const { currentAppointment, notes, executingCancellation, reschedule, cancelling, visitUrlSaved } = state;
  const startTime = get(currentAppointment, 'startISOTime');
  const endTime = get(currentAppointment, 'endISOTime');
  const deadline = get(node, 'highSchool.repVisitsAccount.availabilitySettings.modifyDeadline');
  const startDay = get(node, 'date');
  const eventDate = getDate(startDay, startTime);
  const highSchool = get(node, 'highSchool');
  const appointment = getAppointmentFromProps(props);
  const visitCreator = get(appointment, 'visitCreator');
  const eventDetails = {
    contact: get(node, 'highSchool.repVisitsAccount.primaryContact'),
    phone: get(node, 'highSchool.repVisitsAccount.primaryContactPhone'),
    instructions: get(node, 'highSchool.repVisitsAccount.webInstructions'),
    title: get(node, 'highSchool.name'),
    timezone: get(node, 'timezone'),
    startISOTime: startTime,
    endISOTime: endTime,
    date: startDay,
  };
  const chosenVisitLocationType = get(currentAppointment, 'chosenVisitLocationType');
  const isVirtualEvent = chosenVisitLocationType === REPVISITS_LOCATION_TYPE.VIRTUAL;
  return {
    node,
    currentAppointment,
    notes,
    executingCancellation,
    reschedule,
    cancelling,
    startTime,
    endTime,
    deadline,
    startDay,
    eventDate,
    highSchool,
    eventDetails,
    chosenVisitLocationType,
    isVirtualEvent,
    onlyVisitUrl,
    visitUrlSaved,
    visitCreator,
  };
};

export function getStartingState(props) {
  const currentAppointment = getAppointmentFromProps(props);
  const visitUrl = get(currentAppointment, 'visitUrl', '');
  return {
    currentAppointment,
    notes: get(currentAppointment, 'notes', ''),
    visitUrl,
    visitUrlError: false,
    loadingVisitUrlConfirmation: false,
    visitUrlSaveFailure: false,
    visitUrlSaved: false,
    highSchoolId: null,
    cancelling: false,
    executingCancellation: false,
  };
}
